{
	"communities": [
		{
			"name": "Netherlands",
			"country_local": "Nederland",
			"lat": 52,
			"lon": 5.6,
			"link": "https://chat.whatsapp.com/EOGvhoPCiCqDqwuf9JUxtB"
		},
		{
			"name": "Serbia",
			"country_local": "Srbija",
			"lat": 44,
			"lon": 21,
			"link": "https://pauseai.rs/"
		},
		{
			"name": "United Kingdom",
			"lat": 54.2,
			"lon": -2.4,
			"link": "https://pauseai.uk/",
			"lumaCalendarId": "cal-Z327EhtiFdHuVie"
		},
		{
			"name": "France",
			"lat": 47.8,
			"lon": 2.6,
			"link": "https://pauseia.fr"
		},
		{
			"name": "Canada",
			"lat": 56,
			"lon": -105,
			"link": "https://pauseai.ca/en/",
			"lumaCalendarId": "cal-tsYv79s4aTQC16Q"
		},
		{
			"name": "Romania",
			"country_local": "România",
			"lat": 44.5,
			"lon": 26,
			"link": "https://pauseai.ro/"
		},
		{
			"name": "Kenya",
			"lat": 0.5,
			"lon": 38,
			"link": "https://x.com/Pauseaikenya"
		},
		{
			"name": "Spain",
			"country_local": "España",
			"lat": 41.3,
			"lon": -4,
			"link": "https://pauseai.es"
		},
		{
			"name": "Australia",
			"lat": -25,
			"lon": 134.5,
			"link": "https://pauseai.info/australia",
			"lumaCalendarId": "cal-gnpo62PdSdau7KQ"
		},
		{
			"name": "Germany",
			"country_local": "Deutschland",
			"lat": 51.1,
			"lon": 10,
			"link": "https://www.pause-ai.de/",
			"lumaCalendarId": "cal-B1ELepcLXLcAqMf"
		},
		{
			"name": "Czechia",
			"country_local": "Česko",
			"lat": 50,
			"lon": 15,
			"link": "https://www.pauseai.cz/"
		},
		{
			"name": "Poland",
			"country_local": "Polska",
			"lat": 52,
			"lon": 19.5,
			"link": "https://pauseai.pl/"
		},
		{
			"name": "Nigeria",
			"lat": 9.5,
			"lon": 8,
			"link": "https://chat.whatsapp.com/L4o2IiOX1HI2GWQi0J9ZJv"
		},
		{
			"name": "Sweden",
			"country_local": "Sverige",
			"lat": 65,
			"lon": 17,
			"link": "https://pauseai.se/",
			"lumaCalendarId": "cal-uTqRuOkL7KPhEu7"
		},
		{
			"name": "Italy",
			"country_local": "Italia",
			"lat": 42.5,
			"lon": 12.5,
			"link": "https://www.pauseai.it/"
		},
		{
			"name": "Belgium",
			"lat": 50.6402809,
			"lon": 4.6667145,
			"link": "https://luma.com/PauseAI.be",
			"lumaCalendarId": "cal-UGDktH7dp8kRqiv"
		},
		{
			"name": "Ghana",
			"lat": 8.0300284,
			"lon": -1.0800271,
			"link": "mailto:ewura@pauseai.info"
		},
		{
			"name": "Ireland",
			"lat": 52.865196,
			"lon": -7.9794599,
			"link": "https://chat.whatsapp.com/KCA0ZFptOKS03dhqmnfDjn"
		},
		{
			"name": "Switzerland",
			"lat": 46.7985624,
			"lon": 8.2319736,
			"link": "https://chat.whatsapp.com/BKt0uKPVLDKFLomW4CrTVH",
			"lumaCalendarId": "cal-lMws4StD94Vb02J"
		},
		{
			"name": "Japan",
			"lat": 36.5748441,
			"lon": 139.2394179,
			"link": "https://chat.whatsapp.com/Kgl95eeW4AiENrl9g5kBHh",
			"country_local": "日本"
		},
		{
			"name": "Uganda",
			"lat": 1.5333554,
			"lon": 32.2166578,
			"link": ""
		}
	]
}
